const APP_THEME_ATTRIBUTE = 'data-theme';
const EDGELESS_PRESET_ATTRIBUTE = 'data-edgeless-preset';

/**
 * Watches the DOM attributes that select the effective Edgeless grid colors.
 *
 * The grid image for crosses and lines is materialized as an inline SVG data
 * URL, so CSS variable changes alone cannot recolor an existing image. Both
 * the app theme and the document-specific Edgeless preset can change the
 * variables used to build that image.
 */
export function observeEdgelessGridThemeAttributes(
  viewport: Element,
  onChange: () => void,
  appRoot: Element = document.documentElement
) {
  const observer = new MutationObserver(onChange);
  observer.observe(viewport, {
    attributes: true,
    attributeFilter: [EDGELESS_PRESET_ATTRIBUTE],
  });
  observer.observe(appRoot, {
    attributes: true,
    attributeFilter: [APP_THEME_ATTRIBUTE],
  });

  return () => observer.disconnect();
}
